var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBLineImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2297,
    cy: 12.9175,
    r: 9,
    transform: "rotate(-42.4965 13.2297 12.9175)",
    fill: "white",
    stroke: "#31B4F2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68693 11.8522L10.4307 10.2545C11.1823 9.56593 11.8491 9.1539 12.4311 9.01845C13.0186 8.87804 13.5575 9.07548 14.048 9.61077C14.3551 9.94601 14.5289 10.304 14.5694 10.6846C14.6049 11.0599 14.4931 11.4209 14.234 11.7677L14.2711 11.8083C14.5216 11.6583 14.7753 11.5552 15.0321 11.499C15.2943 11.4378 15.5634 11.4547 15.8395 11.5499C16.1107 11.6396 16.385 11.8358 16.6624 12.1386C17.143 12.6631 17.3305 13.2422 17.2249 13.876C17.1193 14.5098 16.7475 15.119 16.1095 15.7036L13.9927 17.6431L8.68693 11.8522ZM11.8875 13.2612L12.731 12.4884C13.1419 12.1119 13.3636 11.7894 13.3961 11.5209C13.4291 11.242 13.3316 10.9783 13.1037 10.7295C12.8659 10.47 12.6004 10.3702 12.3071 10.43C12.0193 10.4849 11.6753 10.6956 11.2751 11.0622L10.5128 11.7607L11.8875 13.2612ZM12.6529 14.0966L14.2357 15.8241L15.1765 14.9621C15.5983 14.5757 15.8159 14.2271 15.8295 13.9162C15.8436 13.5951 15.7292 13.302 15.4865 13.037C15.2536 12.7829 14.9813 12.6594 14.6696 12.6666C14.3633 12.6687 13.9884 12.8729 13.545 13.2792L12.6529 14.0966Z",
    fill: "#363948"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBLineImg);
export default __webpack_public_path__ + "static/media/b-line-img.0e7bf38bbdd39d7eb3070247a3e526e9.svg";
export { ForwardRef as ReactComponent };